import { HttpMethod } from "../common/lib/fetch/useFetch";
import useRequest, { RequestOptions } from "../common/lib/fetch/useRequest";

const useArrivedAtReceiving = (stagedPurchaseOrderId: string, bayId?: string, options?: RequestOptions) =>
  useRequest<void>({
    headers: () => Promise.resolve(new Headers()),
    method: HttpMethod.POST,
    path: `/api/developer/stagedPurchaseOrders/${stagedPurchaseOrderId}/arrivedAtReceiving/${bayId}`
  }, options);

export default useArrivedAtReceiving;
